import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';
import * as i1 from '@angular/common/http';
import * as errorUtils from 'error-message-utility';
import * as i1$1 from '@ngrx/store';
import { select } from '@ngrx/store';
import { getStepDetails, updateStepStatus, updateStepStatusToInitialState } from 'visa-store';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import * as i5 from 'dirty-check-store';
import { MarkDirtyFormAction, MarkCleanFormAction } from 'dirty-check-store';
import * as i3 from 'ngx-toastr';
import * as i4 from 'step-status-update-payload-service';
import * as i6 from 'app-services-library';

class APISubmitPetition {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getStatusAndResponse(stepTypeCode) {
        return this.httpClient.get(`/step/${stepTypeCode}/statusAndResponse`).pipe(map(response => {
            return response['data'];
        }));
    }
    postActionCode(visatype, taskId, stepId, payload) {
        return this.httpClient.post(`/${visatype}/task/${taskId}/step/${stepId}/update`, payload).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    getReceiptDetails(visaType, caseType, caseId) {
        return this.httpClient.get(`/${visaType}/${caseType}/${caseId}/receiptInfo`).pipe(map((response) => {
            if (response.status === 200 || response.status === 204) {
                return response;
            }
        }));
    }
    postI140ActionCode(superTaskId, actionCode, payload) {
        return this.httpClient.post(`/greenCard/task/${superTaskId}/actionCode/${actionCode}`, payload).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    getI140ReceiptDetails(superTaskId, subTaskId, i140CaseId) {
        return this.httpClient.get(`/superTask/${superTaskId}/subTask/${subTaskId}/gc/i140Case/${i140CaseId}/receiptInfo`).pipe(map((response) => {
            if (response.status === 200 || response.status === 204) {
                return response;
            }
        }));
    }
}
APISubmitPetition.ɵfac = function APISubmitPetition_Factory(t) { return new (t || APISubmitPetition)(i0.ɵɵinject(i1.HttpClient)); };
APISubmitPetition.ɵprov = i0.ɵɵdefineInjectable({ token: APISubmitPetition, factory: APISubmitPetition.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(APISubmitPetition, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

// import { I140FileUploadConfiguration } from '../../../../data/models/i140UploadConfiguration';
class BaseSubmitPetitionLibraryService {
    constructor(store, apiService, toastr, stepStatusUpdatePayloadCostruction, guard, appServicesLibraryService) {
        this.store = store;
        this.apiService = apiService;
        this.toastr = toastr;
        this.stepStatusUpdatePayloadCostruction = stepStatusUpdatePayloadCostruction;
        this.guard = guard;
        this.appServicesLibraryService = appServicesLibraryService;
        this.isWizard = false;
        this.observableSubscription$ = new Subject();
        this.onSubmit$ = new Subject();
        this.submitPetition = {
            receiptDate: null,
            receiptNumber: '',
            submissionAckno: '',
            submitResponseCode: '',
            submitResponseName: ''
        };
    }
    loadInit() {
        this.getStatusype();
        if (!sessionStorage.getItem('wizardTID')) {
            this.store.pipe(select(getStepDetails, { id: this.inputData.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
                this.typeOfButton = data.isPetitionerAction === 1 || data.isAttorneyAction === 1 || data.isBeneficiaryAction === 1 ? "MARK_COMPLETE" : "MARK_SUBMIT";
                this.stepDetails = data;
                this.getSubmitPetition();
                this.fileUploadConfigurations = Object.assign({}, {
                    disableControls: this.disabledControls,
                    isDocumentTypeRequired: false,
                    isDocumentUploadRequired: true,
                    isViewEnabled: true,
                    isDownloadEnabled: true,
                    isDeleteEnabled: true,
                    getApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/TRACKRCPT/`,
                    postApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/TRACKRCPT/fileCategory/`,
                    deleteApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/`,
                    documentTypeDropdownCode: 'TRACKRCPT'
                });
                this.toggleControlsStatus();
            });
        }
        else {
            this.getSubmitPetition();
            this.fileUploadConfigurations = Object.assign({}, {
                disableControls: this.disabledControls,
                isDocumentTypeRequired: false,
                isDocumentUploadRequired: true,
                isViewEnabled: true,
                isDownloadEnabled: true,
                isDeleteEnabled: true,
                getApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/TRACKRCPT/`,
                postApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/TRACKRCPT/fileCategory/`,
                deleteApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/`,
                documentTypeDropdownCode: 'TRACKRCPT'
            });
        }
    }
    afterViewInit() {
        this.submitPetitionForm.form.valueChanges.pipe(map(() => this.submitPetitionForm.dirty)).pipe(takeUntil(this.observableSubscription$)).subscribe(dirty => {
            if (dirty) {
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true
                }));
            }
            else {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
            }
        });
    }
    getStatusype() {
        this.apiService.getStatusAndResponse('SUBPET')
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.statusTypeList = response['response'] && response['response'].filter(ele => ele.stepResponseCode === 'SUBMITTED');
        });
    }
    getSubmitPetition() {
        // if (this.inputData.caseType === 'I140') {
        //   this.apiService.getI140ReceiptDetails(this.inputData.superTaskId,
        //     this.inputData.subTaskId, this.inputData.caseId).subscribe((response: ImagilityBaseResponse) => {
        //       if (response) {
        //         this.submitPetition = response.data;
        //       }
        //     });
        // } else {
        this.apiService.getReceiptDetails(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response) {
                this.submitPetition = response.data;
                //this.submitPetition.submissionAckno = this.submitPetition.receiptNumber;
            }
        });
        //  }
        this.fileUploadConfigurations = Object.assign({}, this.fileUploadConfigurations);
    }
    postsubmitPetition() {
        const submitPayload = {
            benchMarkActionCode: "",
            endDate: "",
            isAttorneyNotify: 0,
            isBeneficiaryNotify: 0,
            isPetitionerNotify: 0,
            receiptCategory: "",
            receiptDate: "",
            receiptNumber: this.submitPetition.submissionAckno,
            receiptType: "",
            responseCode: this.submitPetition.submitResponseCode,
            responseNote: "",
            reviewCode: "",
            reviewNote: "",
            startDate: "",
            statusCode: "",
            stepNote: "",
        };
        let visaType = this.inputData.visatype;
        if (this.inputData.caseType == "I130") {
            visaType = this.inputData.caseType;
        }
        if (this.inputData.caseType === 'I140') {
            this.apiService.postI140ActionCode(this.inputData.subTaskId, this.stepDetails.stepActionList[0].layoutCode, submitPayload).subscribe((response) => {
                if (response && response.status === 200) {
                    this.toastr.success(response.message, 'Success');
                    this.submitPetitionForm.resetForm();
                    if (this.stepDetails.stepStatusDetails.stepStatusCode === 'NEW') {
                        this.updateStepStatus('INPROGRESS');
                    }
                    this.getSubmitPetition();
                }
            });
        }
        else {
            this.apiService.postActionCode(visaType, this.inputData.subTaskId, this.inputData.stepId, submitPayload)
                .pipe(takeUntil(this.observableSubscription$))
                .subscribe((response) => {
                var _a, _b;
                if (response && response.status === 200) {
                    this.toastr.success(response.message, 'Success');
                    this.submitPetitionForm.resetForm();
                    this.onSubmit$.next(true);
                    if (((_b = (_a = this.stepDetails) === null || _a === void 0 ? void 0 : _a.stepStatusDetails) === null || _b === void 0 ? void 0 : _b.stepStatusCode) === 'NEW') {
                        this.updateStepStatus('INPROGRESS');
                    }
                    else {
                        this.getSubmitPetition();
                    }
                }
            });
        }
    }
    updateStepStatus(status) {
        this.store.dispatch(updateStepStatus({
            payload: this.stepStatusUpdatePayloadCostruction.payloadConstruction(this.stepDetails, status),
            subTaskId: this.stepDetails.taskId,
            visaType: this.inputData.caseType === 'I130' ?
                this.inputData.caseType : this.inputData.visatype,
            stepId: this.inputData.stepId
        }));
    }
    //Toggle controls status based on step status
    toggleControlsStatus() {
        this.disabledControls = this.appServicesLibraryService.formToBeDisabled(this.stepDetails.stepStatusDetails.stepStatusCode);
        // this.disabledControls = this.stepDetails.stepStatusDetails.stepStatusCode === "NEW" || this.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" || this.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT" ? true : false;
        this.fileUploadConfigurations = Object.assign({}, {
            disableControls: this.disabledControls,
            isDocumentTypeRequired: false,
            isDocumentUploadRequired: true,
            isViewEnabled: true,
            isDownloadEnabled: true,
            isDeleteEnabled: true,
            getApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/TRACKRCPT/`,
            postApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/TRACKRCPT/fileCategory/`,
            deleteApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/`,
            documentTypeDropdownCode: 'TRACKRCPT'
        });
    }
    getGlobalErrorMessages(error) {
        return errorUtils.errorMessages.get(error);
    }
    handleCancel() {
        this.getSubmitPetition();
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
        this.onSubmit$.next();
        this.onSubmit$.complete();
        // Update the Step Status state to empty state
        this.store.dispatch(updateStepStatusToInitialState());
    }
}
BaseSubmitPetitionLibraryService.ɵfac = function BaseSubmitPetitionLibraryService_Factory(t) { return new (t || BaseSubmitPetitionLibraryService)(i0.ɵɵinject(i1$1.Store), i0.ɵɵinject(APISubmitPetition), i0.ɵɵinject(i3.ToastrService), i0.ɵɵinject(i4.StepStatusUpdatePayloadService), i0.ɵɵinject(i5.DirtyFormGuard), i0.ɵɵinject(i6.AppServicesLibraryService)); };
BaseSubmitPetitionLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: BaseSubmitPetitionLibraryService, factory: BaseSubmitPetitionLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BaseSubmitPetitionLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1$1.Store }, { type: APISubmitPetition }, { type: i3.ToastrService }, { type: i4.StepStatusUpdatePayloadService }, { type: i5.DirtyFormGuard }, { type: i6.AppServicesLibraryService }]; }, null); })();

/*
 * Public API Surface of base-submit-petition-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { APISubmitPetition, BaseSubmitPetitionLibraryService };
//# sourceMappingURL=base-submit-petition-library.js.map
